import { ComponentProps } from "react";

export default function FlagIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5 3V16.4121L10.3252 12.835L10 12.5557L9.6748 12.835L5.5 16.4121V3H14.5Z"
        stroke="currentColor"
      />
    </svg>
  );
}
